import { render, staticRenderFns } from "./AddPosturaActiveTask.vue?vue&type=template&id=987e6438"
import script from "./AddPosturaActiveTask.vue?vue&type=script&lang=js"
export * from "./AddPosturaActiveTask.vue?vue&type=script&lang=js"
import style0 from "./AddPosturaActiveTask.vue?vue&type=style&index=0&id=987e6438&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports